"use client"

import React from 'react'
import Image from 'next/image';
import { useGame } from '@/app/providers/GameContextProvider';
import { GameStep } from '@/lib/types/common/GameStep';
import { useTranslation } from '@/hooks/useTranslation';
import { useGameQuality } from '@/app/providers/GameQualityProvider';
import { useDeviceInfo } from '@/hooks/useIsMobile';
import LanguageSwitcher from './LanguageSwitcher';

interface NavbarProps {
    showLanguageSwitcher?: boolean;
}

const Navbar = ({ showLanguageSwitcher = false }: NavbarProps) => {
    const { gameState } = useGame();
    const { t } = useTranslation();
    const { getBackdropBlurIntensity } = useGameQuality();
    const { isMobile } = useDeviceInfo();

    const isLobby = gameState?.gameStep === GameStep.LOBBY;

    const handleClickLogo = () => {
        if (isLobby) return;
        if (gameState?.gameStep === GameStep.GUESSING || gameState?.gameStep === GameStep.RESULT) {
            if (window.confirm(t('play.confirmLeaveGame'))) {
                window.location.href = '/';
            }
        } else {
            window.location.href = '/';
        }
    }

    return (
        <div className={`h-12 top-0 text-white absolute w-full flex justify-between z-[100] select-none pointer-events-none ${isMobile ? 'bg-black/50' : ''}`}>
            {!isMobile && (
                <>
                    <div className={`absolute h-[55px] w-[500px] ${getBackdropBlurIntensity('sm')}`} style={{ maskImage: 'linear-gradient(to right, white, transparent)' }}></div>
                    <div className="absolute h-[55px] w-[500px] blur-sm bg-gradient-to-r from-black/80 to-transparent"></div>
                    {showLanguageSwitcher && (
                        <>
                            <div className={`absolute h-[55px] w-[500px] right-0 ${getBackdropBlurIntensity('sm')}`} style={{ maskImage: 'linear-gradient(to left, white, transparent)' }}></div>
                            <div className="absolute h-[55px] w-[500px] right-0 blur-sm bg-gradient-to-l from-black/80 to-transparent"></div>
                        </>
                    )}
                </>
            )}
            <div
                onClick={handleClickLogo}
                className={`h-12 flex items-center mt-1 relative gap-2 ${!isLobby ? 'cursor-pointer pointer-events-auto' : ''} ${isMobile ? 'ml-1' : 'ml-4'}`}
            >
                <Image
                    src="/logo.png"
                    alt="Eorguessr"
                    width={42}
                    height={42}
                    className={`z-30 ${isMobile ? '-translate-y-[3px]' : ''}`}
                />
                {(!isMobile || (isMobile && isLobby)) && (
                    <Image
                        src="/eorguessr.png"
                        alt="Eorguessr"
                        width={isMobile ? 140 : 180}
                        height={isMobile ? 20 : 24}
                        className={`z-30 ${isMobile ? '-translate-y-[3px]' : ''}`}
                    />
                )}
            </div>
            {showLanguageSwitcher && (
                <div className={`h-12 flex items-center mt-1 relative ${isMobile ? 'mr-1' : 'mr-4'}`}>
                    <div className="z-30 text-[#FFFBD4] text-shadow shadow-yellow-800/90">
                        <LanguageSwitcher />
                    </div>
                </div>
            )}
        </div>
    )
}

export default Navbar